import React from "react";
import { CheckCircle2 } from "lucide-react";

/** "100% finançable" badge. Placement is the caller's job (see PriceCard / FicheHero). */
const FinanceablePill: React.FC<{ className?: string }> = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-[#C7F8FF] text-[#1B365E] text-[11px] font-bold leading-5 px-2.5 py-1 ${className}`}
  >
    {/* `bg-border-round` was not a class — dropped rather than left dangling. */}
    <CheckCircle2 className="size-3.5 shrink-0 rounded-full bg-[#B6C93E]" aria-hidden="true" />
    100% finançable
  </span>
);

export default FinanceablePill;
